import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const tasktodoAPI = createApi({
    reducerPath:"tasktodoAPI",
    baseQuery:customFetchBase,
    endpoints:(builder)=>({ 

        addTaskTodo: builder.mutation({
            query: (data) => ({
                url: `/TaskTODO/AddTaskTODO`,
                method: 'POST',
                body: transformRequest(data), 
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
          }),

          getAllTaskTodoList: builder.query({
            query: ({projectId,taskId}) => ({
                url: `/TaskTODO/GetTaskTODOByProjectAndTaskId?ProjectId=${projectId}&TaskId=${taskId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
          }),
          deleteTaskTodo:builder.mutation({
            query: (id) => ({
                url: `/TaskTODO/DeleteTodoTaskById?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTaskTodoById: builder.query({
            query: (TaskTodoId) => ({
                url: encryptQueryString(`TaskTODO/GetTaskTodoById?TaskTodoId=${Number(TaskTodoId)}`),
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateTaskTodo: builder.mutation({
            query: (Data) => ({
                url: '/TaskTODO/UpdateTODOTaskByTaskTODOId',
                method: 'POST',
                body: transformRequest(Data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {
    useLazyGetAllTaskTodoListQuery,
    useLazyGetTaskTodoByIdQuery,
    useAddTaskTodoMutation,
    useUpdateTaskTodoMutation,
    useDeleteTaskTodoMutation

} =tasktodoAPI;

export default tasktodoAPI;